import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { fade } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import Typography from 'Components/UI/Typography';
import Switch from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Switch';
import { useDebugDispatch, useDebugState } from 'Context/DebugContext';

const styles = theme => ({
  root: {
    position: 'fixed',
    bottom: 20,
    left: 20,
    zIndex: theme.zIndex.modal,
  },
  paper: {
    position: 'relative',
    backgroundColor: fade(theme.palette.facet.slate, 0.8),
    padding: theme.spacing(2),
    borderRadius: theme.radius.sm,
  },
  header: {},
  closeButton: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
});

const DebugPanelPanel = ({
  children,
  className,
  classes,
  onClose,
}) => {
  const debugDispatch = useDebugDispatch();
  const debugState = useDebugState();

  return (
    <div className={classes.root}>
      <Paper
        className={classNames(classes.paper, className)}
        variant="outlined"
      >
        <div className={classes.header}>
          <Typography
            variant="h4"
            color="white"
          >
            {'Debug Panel'}
          </Typography>
          <IconButton
            className={classes.closeButton}
            title="Close Panel"
            color="primaryGray"
            icon={CloseIcon}
            onClick={onClose}
          />
        </div>
        <div className={classes.content}>
          <Switch
            color="accentBlue"
            label="Show Debug Colors"
            labelColor="white"
            onChange={() => {
              debugDispatch({ type: 'toggleDebugColors' });
            }}
            value={debugState.showDebugColors}
          />
          <Switch
            color="accentBlue"
            label="Show Debug Context"
            labelColor="white"
            onChange={() => {
              debugDispatch({ type: 'toggleDebugContextData' });
            }}
            value={debugState.showDebugContextData}
          />
          <Switch
            color="accentBlue"
            label="Show Dev Elements"
            labelColor="white"
            onChange={() => {
              debugDispatch({ type: 'toggleDevElements' });
            }}
            value={debugState.showDevElements}
          />
          <Switch
            color="accentBlue"
            label="Toggle Meeting Information"
            labelColor="white"
            onChange={() => {
              debugDispatch({ type: 'toggleMeetingInformation' });
            }}
            value={debugState.showMeetingInformation}
          />
        </div>
        {children}
      </Paper>
    </div>
  );
};

DebugPanelPanel.defaultProps = {
  className: '',
  children: null,
};

DebugPanelPanel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(DebugPanelPanel);
